import {isArray} from 'lodash/lang';

export const hasPermission = state => code => {
    let permissions = state.permissions;
    if (isArray(permissions) && permissions.length > 0) {
        return permissions.indexOf(code) !== -1;
    } else {
        return false;
    }
};
